import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axiosInstance from '../utils/axiosInstance'
import { toast } from 'react-toastify';

const initialState = {
  loading: false,
  contacts: [],
  count:0,
  next: null,
  previous: null,
  total_pages: 0,
  error: {},
}

export const fetchContacts = createAsyncThunk('contactSlice/fetchContacts', async (queyString, thunkAPI) => {
  
  try {
    const response = await axiosInstance.get(`/leads/contact${queyString ?queyString :''}`);
    return response.data; 
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || 'Failed to fetch roles');
  }
});

export const deleteContact = createAsyncThunk('contactSlice/deleteContact', async (id, thunkAPI) => {

  try {
    const response = await axiosInstance.delete(`/leads/contact/${id}`);
    console.log("response in del", response);
    response.data = id
    return response;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || 'Failed to delete role');
  }
});


export const createContact = createAsyncThunk('contactSlice/createContact', async (values, thunkAPI) => {

  try {
    const response = await axiosInstance.post('/leads/contact', values);
    return response
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || 'Failed to delete role');
  }
});

export const toggleActivation = createAsyncThunk('contactSlice/toggleActivation', async (id, thunkAPI) => {

  try {
    const response = await axiosInstance.post(`/leads/contact/${id}/toggle-activation`);
    return response
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || 'Failed to delete role');
  }
});

export const exportContactLeads = createAsyncThunk('leadSlice/exportContactLeads', async (values, thunkAPI) => {

  try {
    const response = await axiosInstance.post(`/leads/contact/export_leads?export_leads?export_type=share`, values);
    return response;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || 'Failed to fetch roles');
  }
});

export const contactSlice = createSlice({
  name: 'contactSlice',
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    // fetch contacts
    builder.addCase(fetchContacts.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(fetchContacts.fulfilled, (state, action) => {
      console.log("action.payload",action.payload);
      state.contacts = action.payload?.data?.results;
      state.next = action.payload?.data?.next;
      state.total_pages = action.payload?.data?.total_pages;
      state.previous = action.payload?.data?.previous;
      state.count = action.payload?.data?.count;
      state.loading = false;
    });
    builder.addCase(fetchContacts.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    //create contacts
    builder.addCase(createContact.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(createContact.fulfilled, (state, action) => {
      state.loading = false;
      state.contacts = [action?.payload?.data.data,...state.contacts];
      if(action?.payload?.status==201){
        toast.success("Contact created successfully")
      }
    });
    builder.addCase(createContact.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    builder.addCase(deleteContact.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(deleteContact.fulfilled, (state, action) => {
      state.loading = false;
      state.contacts = state.contacts.filter((ele)=>ele.uuid !==action?.payload?.data);
      if(action?.payload?.status==204){
        toast.success("Contact deleted successfully")
      }
    });
    builder.addCase(deleteContact.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    // active incative contact
    builder.addCase(toggleActivation.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(toggleActivation.fulfilled, (state, action) => {
      console.log("action",action);
      const id=action?.payload?.data?.data?.id;
      state.contacts = state.contacts.map(platform =>
        platform.id === id ? action?.payload?.data?.data : platform
      );  
      state.loading = false;
      state.error = null;
      if(action?.payload?.status==200){
        toast.success("Contact updated successfully")
      }
    });
    builder.addCase(toggleActivation.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
})


export default contactSlice.reducer